//Limitless imports
import { passExpertMessage } from "../../portal";
import { log as pilog } from "@limitless/common/utils";
import { useExpertMessageContext } from "./expert-message/ExpertMessageContext";
import { useExpertTaskListContext } from "./expert-task-list/ExpertTaskListContext";
export const useMessagePass = () => {
  const log = pilog.getLogger("useMessagePass");
  const messageContext = useExpertMessageContext();
  const {
    tasklistFilters,
    removeTasklistRecord,
    updateTaskListRecord
  } = useExpertTaskListContext();
  log.debug(messageContext);
  const {
    message,
    setMessage
  } = messageContext;
  const processMessagePass = message => {
    if (tasklistFilters.passedTasks.pass.value) {
      updateTaskListRecord(message.inbox);
    } else {
      removeTasklistRecord(message.messageId);
    }
  };
  const processMessageRestore = message => {
    removeTasklistRecord(message.messageId);
    // if (tasklistFilters.passedTasks.pass.value) {
    //     removeTasklistRecord(message.messageId);
    // } else {
    //     updateTaskListRecord(message.inbox);
    // }
  };
  const passMessage = (pass, message = message) => {
    const newMessage = {
      ...message
    };
    if (newMessage !== null && newMessage !== void 0 && newMessage.inbox) {
      newMessage.inbox.passed = pass;
      log.debug(newMessage);
      newMessage.inbox.body = message.body;
    } else {
      newMessage.passed = pass;
      log.debug(newMessage);
      newMessage.body = message.body;
    }
    setMessage({
      ...newMessage
    });
    updateTasklistMessage({
      ...newMessage
    }, pass);
  };
  const passTasklistMessage = (message, pass, callback) => {
    const newMessage = {
      ...message
    };
    updateTasklistMessage(newMessage, pass);
    callback();
  };
  const unPassMessage = (message, callback) => {
    const newMessage = {
      ...message
    };
    newMessage.passed = false;
    log.debug(newMessage);
    newMessage.body = message.body;
    passExpertMessage(newMessage, false, response => {
      callback(response);
    });
  };
  const updateTasklistMessage = (message, pass) => {
    if (pass) {
      processMessagePass(message);
    } else {
      processMessageRestore(message);
    }
    passExpertMessage(message, pass, response => {
      if (response.hasError) {
        log.debug(response);
      }
    });
  };

  // Make the context object:
  return {
    passMessage,
    unPassMessage,
    passTasklistMessage
  };
};